import { Link } from 'react-router-dom';

export function ComingSoonPage({ title }: { title: string }) {
  return (
    <div className="p-8">
      <h1 className="text-xl font-semibold text-brand">{title}</h1>
      <p className="mt-2 text-sm text-slate-600">
        Not yet built in v2. The legacy app at <a className="text-brand underline" href="http://localhost:210/" target="_blank" rel="noreferrer">localhost:210</a> still has this page.
      </p>
      <p className="mt-2 text-sm text-slate-500">
        See <code>v2/README.md</code> § module status. <Link className="text-brand underline" to="/dashboard">Back to dashboard</Link>
      </p>
    </div>
  );
}
